import { getEnvironmentUrlApiV2 } from './getEnvironmentUrlApiV2';

export async function previewVideo(
  authToken: string,
  environment: Parameters<typeof getEnvironmentUrlApiV2>[0],
  videoId: string,
): Promise<unknown> {
  const res = await fetch(`${getEnvironmentUrlApiV2(environment)}videos/${videoId}/player`, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    }),
  });

  if (res.ok) {
    return res.json();
  }

  return false;
}
